import CurrentBadge from '@icons/current-badge.svg';
import InfoCircle from '@icons/info-circle.svg';
import InfoCircleDeloitte from '@icons/info-circle-deloitte.svg';
import { useThemeStore } from 'src/stores/ThemeStore';
import styles from './RoleButton.module.scss';

interface RoleButtonProps {
  isCurrent: boolean;
  mainText: string;
  subText: string;
}

const HR_INFO_MESSAGE =
  'When you switch roles to HR, it’s best to view on desktop or a larger device for the best experience';

const RoleButton = ({ isCurrent, mainText, subText }: RoleButtonProps) => {
  const { isDeloitteTheme } = useThemeStore();

  return (
    <>
      <div className={styles['role-button'] + (isCurrent ? ' role-selected' : '')}>
        <div className={styles.content}>
          <h4 className={styles.title}>{mainText}</h4>
          <p className={styles.subtext}>{subText}</p>
        </div>
        {isCurrent && (
          <div className={styles.badge}>
            <img src={CurrentBadge} />
          </div>
        )}
      </div>
      {!isCurrent && (
        <div className={styles['warning-message']}>
          <img src={isDeloitteTheme ? InfoCircleDeloitte : InfoCircle} className={styles.icon} />
          <p>{HR_INFO_MESSAGE}</p>
        </div>
      )}
    </>
  );
};

export default RoleButton;
